var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.displayValue},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }